export const IconPlaySquare = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <mask
        id="IconPlaySquare_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconPlaySquare_svg__a)">
        <path d="M15.85 12.425q.225-.15.225-.425a.48.48 0 0 0-.225-.425L10.275 8a.445.445 0 0 0-.513-.025.49.49 0 0 0-.262.45v7.15q0 .3.262.45t.513-.025zM5 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 19V5q0-.824.587-1.412A1.93 1.93 0 0 1 5 3h14q.824 0 1.413.587Q21 4.176 21 5v14q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21zm0-2h14V5H5z" />
      </g>
    </svg>
  );
};
